import { useLocation, Link } from 'react-router';
import { ChevronRight, Home } from 'lucide-react';
import './Breadcrumb.css';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

// Route to breadcrumb mapping
const routeConfig: Record<string, BreadcrumbItem[]> = {
  '/clinics': [
    { label: 'Clinics' }
  ],
  '/clinics/create': [
    { label: 'Clinics', path: '/clinics' },
    { label: 'New Clinic' }
  ],
  '/procedures': [
    { label: 'Procedures' }
  ],
  '/tasks': [
    { label: 'Tasks' }
  ],
};

const Breadcrumb = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // Get breadcrumb items for current route
  const getBreadcrumbItems = (): BreadcrumbItem[] => {
    // Exact match first
    if (routeConfig[pathname]) {
      return routeConfig[pathname];
    }

    // Handle dynamic routes (e.g., /clinics/123)
    if (pathname.startsWith('/clinics/') && pathname !== '/clinics/create') {
      return [
        { label: 'Clinics', path: '/clinics' },
        { label: 'Clinic Details' }
      ];
    }

    // Default fallback
    return [
      { label: 'Home' }
    ];
  };

  const items = getBreadcrumbItems();

  return (
    <nav className="breadcrumb" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        <li className="breadcrumb-item">
          <Link to="/clinics" className="breadcrumb-home" aria-label="Home">
            <Home size={16} />
          </Link>
        </li>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;

          return (
            <li key={index} className="breadcrumb-item">
              <ChevronRight size={14} className="breadcrumb-separator" />
              {item.path && !isLast ? (
                <Link to={item.path} className="breadcrumb-link">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'breadcrumb-current' : 'breadcrumb-text'}>
                  {item.label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
